import 'react'
import {Chart as ChartJS,defaults,CategoryScale,LinearScale,BarElement,Title,Tooltip,Legend,Element,PointElement,LineElement} from 'chart.js';
import { Chart } from 'react-chartjs-2';
//'chart.js' (possible exports: Animation, Animations, ArcElement, BarController, BarElement, BasePlatform, BasicPlatform, BubbleController, CategoryScale, Chart, DatasetController, Decimation, DomPlatform, DoughnutController, Element, Filler, Interaction, Legend, LineController, LineElement, LinearScale, LogarithmicScale, PieController, PointElement, PolarAreaController, RadarController, RadialLinearScale, Scale, ScatterController, SubTitle, Ticks, TimeScale, TimeSeriesScale, Title, Tooltip, _adapters, _detectPlatform, animator, controllers, defaults, elements, layouts, plugins, registerables, registry, scales)


ChartJS.register(CategoryScale);
ChartJS.register(LinearScale);
ChartJS.register(BarElement);
ChartJS.register(Title);
ChartJS.register(Tooltip);
ChartJS.register(Legend);
ChartJS.register(PointElement);
ChartJS.register(LineElement);

//ChartJS.register(Element);


/* eslint eqeqeq: 0 */

global.years =[2018,2019,2020, 2021, 2022, 2023, 2024,2025]

global.shapeGID = 52094;
global.nbShapes = 1;
global.statusAreas = false;
global.zone_name = "Périmètres d'étude";


global.palette1 = ["#264653","#2a9d8f","#8ab17d","#e9c46a","#f4a261","#e76f51","#bc6ff1","#ffcad4"];
global.palette1_1 = ["#6aa4bb","#75dacf","#f2deab","#f9cca7","#f2ae9d"];
global.palette2 = ["#ffadad","#ffd6a5","#fdffb6","#caffbf","#9bf6ff","#a0c4ff","#bdb2ff","#ffc6ff"];
global.palette6col=global.palette1_1;
//var global.palette3col=["#264653","#8ab17d","#f4a261"];
global.palette3col=[global.palette6col[0],global.palette6col[2],global.palette6col[4],global.palette6col[1],global.palette6col[3]];

global.perimeter_name = "Métropole Européenne de Lille"

export default async function getZones (token){
  const[zones] = await Promise.all([
      fetch("https://mel.dvrc.fr/api/zones.php?token="+token).then(res => res.json())
    ]).catch(console.log);
    return zones;
}

/*global.zones = []
global.zones[0] = {"name":"Lille (Commune)", "shapes":"52094"};

global.zones[1] = {"name":"UUPD - Unité Urbaine Partie Dense(INSEE)", "shapes":"73908,57436,62281,77267,57268,70866,80365,81929,56440,66593,79819,52094,60211,63227,53166,70700,61651,54131,78772,82659,79722,67771,51422,57435,63485,59072,51937,73377,64503,53604,50259"};

global.zones[2] = {"name":"UU - Unité Urbaine (INSEE)", "shapes":"78852,63927,80364,76594,72361,67942,49879,71738,73908,57436,58832,62281,75487,59887,77267,74560,57268,70866,80365,81929,56440,79820,66593,79819,52094,65254,75485,60211,63227,53166,70700,61651,54131,78772,56373,81466,81367,64218,82659,79722,67771,57269,51422,60201,52804,57435,63485,59072,51937,57708,48838,71737,73377,59380,64503,53604,50259,64504,63599"};

global.zones[3] = {"name":"MEL - Métropole Européenne de Lille", "shapes":"78852,73252,75424,80364,73710,61397,76594,72361,59718,67942,49879,71738,73908,72286,57863,57436,58832,81487,67941,73251,61529,62281,75487,73253,71323,60033,71209,59887,77267,74560,58160,57268,70866,64016,72285,69374,75486,79443,82331,80365,81929,56440,79820,66593,66837,79819,52094,65254,75485,60211,63227,53166,70700,61396,61651,54131,78772,56373,81466,76914,81367,64218,64285,82659,79722,67771,57269,73917,57808,51422,61810,60201,52804,57435,63485,59072,51937,57708,48838,71737,73377,59380,50513,64503,53604,50259,66207,64504,60029,63599,67337,74264,65249,78015,71449"};

global.zones[4] = {"name":"MEL - Hors Lille", "shapes":"78852,73252,75424,80364,73710,61397,76594,72361,59718,67942,49879,71738,73908,72286,57863,57436,58832,81487,67941,73251,61529,62281,75487,73253,71323,60033,71209,59887,77267,74560,58160,57268,70866,64016,72285,69374,75486,79443,82331,80365,81929,56440,79820,66593,66837,79819,65254,75485,60211,63227,53166,70700,61396,61651,54131,78772,56373,81466,76914,81367,64218,64285,82659,79722,67771,57269,73917,57808,51422,61810,60201,52804,57435,63485,59072,51937,57708,48838,71737,73377,59380,50513,64503,53604,50259,66207,64504,60029,63599,67337,74264,65249,78015,71449"};

global.zones[5] = {"name":"Département du Nord", "shapes":"53370,46794,47040,47384,46840,46841,49133,49202,46780,54065,54104,47231,48838,46982,49251,48170,48229,49526,48324,48404,48631,48805,61651,48817,48874,50491,49154,49301,49879,49488,60481,49679,49699,49806,49840,49850,49929,49939,49991,50001,50006,50259,50302,50427,50437,50513,50669,51202,51255,51254,51422,51475,51755,51718,51774,51789,51937,51965,52021,52022,52094,52160,52162,52199,52236,52804,53064,53166,61529,53271,53441,53516,53644,53562,53604,53817,53818,53871,54131,54246,54247,54265,54334,54389,54426,54435,54806,54825,54891,55031,55324,55333,55532,55567,55621,55638,55697,55847,55848,56045,56312,56313,62399,56373,56374,56440,56647,56727,56883,56884,56941,56958,56959,56960,56961,56985,57009,57196,57268,57269,57435,57436,57481,57586,57587,57597,57708,57808,57810,57863,57952,58046,58160,58162,58172,58232,58444,58478,58626,58641,58655,58742,58829,58832,58856,58857,58858,73168,59072,59083,59100,59206,59290,59379,59380,59448,59449,59450,59632,59679,59717,59718,74543,59887,59909,59910,60029,60058,60033,60035,60057,60211,60201,60222,60224,60280,60483,60698,60699,60792,60805,60806,60817,60828,60830,60876,60927,60928,60944,60955,60967,61187,61199,61381,61396,61397,61400,61554,61555,61617,61812,61810,61813,62079,62080,70888,62182,62183,62281,62499,62777,62852,62923,62978,62990,63047,63225,63227,63234,63286,63287,63289,63470,63473,63485,63599,63620,63621,63817,63819,63885,63895,63896,63897,63898,63927,63932,64012,64016,64218,64219,64220,64221,64222,64223,64242,64264,64285,64447,64501,64503,64504,64595,64603,64604,64809,76869,64950,64964,64999,65000,65032,65249,65251,65252,65253,65254,65322,65323,65548,65549,65562,65564,65662,65731,65743,65744,65745,66142,66167,66207,66286,66287,66311,66838,66593,66612,66613,66614,66615,66817,66837,66839,66910,66936,66938,66939,66940,66972,66973,66974,67238,67239,67337,67345,67448,67449,67547,67570,67631,67632,67633,67771,67869,67941,67942,67943,67969,67970,67973,67974,68186,68196,68316,68318,68319,68329,68348,68384,68465,68466,68467,68468,68469,68481,68608,68622,68623,68624,68625,68626,80330,68692,68693,68694,68721,68747,68765,68824,68871,68988,68989,68990,69092,69372,69374,69377,69378,69379,69380,69419,69453,69506,69529,69546,69580,69654,69673,69677,69704,69705,69760,69993,70061,70240,70317,70341,70441,70477,70545,70561,70562,70563,70700,70796,70887,70866,83006,70886,70889,70890,70917,70918,70932,70934,70935,70936,70963,71207,71209,71292,71293,71294,71295,71323,71326,71464,71507,71664,71737,71736,71738,72002,72004,72005,72111,72122,72123,72124,72125,72126,72127,72285,72286,72359,72360,72361,72402,72451,72473,72474,72476,72477,72584,72585,72586,72587,72736,72863,73251,73252,73253,73254,73286,73377,73527,73531,73545,73622,73623,73624,73625,73696,73710,73711,73712,73908,73917,73937,73938,73939,73942,73943,73944,74264,74266,74358,74360,74559,74560,74699,74769,74771,74772,74773,74774,75099,75100,75168,75169,75170,75171,75424,75485,75486,75487,75499,75507,75511,75698,75713,75790,75869,75870,75943,75937,75938,75941,75942,76125,76143,76195,76483,76499,76536,76591,76594,76610,76617,76618,76619,76846,76847,76867,76870,76871,76914,76915,76937,76927,77158,77215,77266,77267,77358,77359,77630,77629,77631,77726,77734,77756,77765,77766,77792,77793,78016,78015,78124,78125,78145,78147,78206,78446,78447,78448,78461,78479,78481,78482,78596,78772,78848,78851,78852,78869,78927,78938,78939,78940,78941,78954,79158,79160,79293,79294,79297,79298,79299,79300,79323,79324,79442,79443,79474,79475,79476,79478,79560,79586,79713,79722,79769,79818,79819,79820,80216,80328,80329,80332,80333,80362,80363,80364,80365,80377,80402,80644,80662,80702,80746,80748,80749,81466,80812,80952,81045,81052,81053,81054,81084,81184,81367,81368,81370,81371,81440,81442,81463,81467,81487,81488,81694,81695,81788,81856,81858,81864,81929,82080,82081,82328,82330,82331,82438,82512,82588,82595,82659,82808,82865,82938,82950,82989,83033,83035,83038,83075,83099,83282"};

global.zones[6] = {"name":"Lille (Canton)", "shapes":"48838,61651,49879,50259,50513,51422,51937,52094,52804,53166,61529,53604,54131,55567,56373,56440,56985,57268,57269,57435,57436,57708,57808,57863,58160,58478,58641,58829,58832,59072,59380,59718,59887,60029,60033,60211,60201,60830,61396,61397,61810,61813,62281,62923,63227,63470,63485,63599,63927,64012,64016,64218,64285,64503,64504,76869,64964,65249,65251,65253,65254,65562,66207,66593,66837,67337,67570,67771,67941,67942,68316,68623,68624,69374,69377,69705,70700,70866,71209,71323,71664,71737,71738,72285,72286,72361,73251,73252,73253,73377,73710,73908,73917,74264,74560,75099,75424,75485,75486,75487,76594,76914,77267,78015,78125,78772,78848,78851,78852,79160,79324,79443,79722,79819,79820,80364,80365,81466,81367,81487,81929,82080,82331,82659"};

global.zones[7] = {"name":"Couronne Nord de Lille", "shapes":"67942,81929,75485,63227,70700,81466,81367,51422,71737,59380"};
global.zones[8] = {"name":"Couronne Sud de Lille", "shapes":"57436,62281,60033,75486,66593,79819,60211,56373,82659,52804,63485,48838,53604"};
global.zones[9] = {"name":"Lille Lomme Hellemmes", "shapes":"57268,80365,52094,65254"};
global.zones[10] = {"name":"Territoire de La Lys", "shapes":"73252,72361,71738,72286,73251,71323,79443,72285,65254,64218,50513,64504"};
global.zones[11] = {"name":"Territoire de Weppes", "shapes":"75424,73710,61397,57863,58832,81487,67941,61529,73253,71209,77267,58160,57268,69374,82331,64016,66837,61396,64285,57808,61810,60201,57435,66207,60029"};
global.zones[12] = {"name":"Territoire Est", "shapes":"78852,80364,59718,49879,75487,59887,61396,76914,57269,73917,57708,73377,63599"};
global.zones[13] = {"name":"Territoire Roubaisiens", "shapes":"73908,70866,56440,79820,63227,67771,59072,64503,50259"};
global.zones[14] = {"name":"Territoire Tourquennois", "shapes":"76594,74560,54131,78772,79722,51937"};
global.zones[15] = {"name":"Autres", "shapes":"67337,74264,80364,67942,81367"};
*
export class Areas extends React.Component {

  render(){
    return (
           <div className="container">
                <div className="alert alert-primary" role="alert">Area - {global.perimeter_name} <a href="#areas" onClick={() => {this.showAreas();}}>({global.nbShapes} communes)</a></div>
                <div className="col"><div id="dataGADM"></div></div>
            </div>
    )
  }

  showAreas (){
    global.statusAreas = !global.statusAreas;
    if(global.statusAreas)
      document.getElementById("dataGADM").style.display = "block";
    else {
      document.getElementById("dataGADM").style.display = "none";
    }
  }
}

/*
export function getAreas(shapeGID, token){
    fetch("https://mel.dvrc.fr/api/GetGadmDataFromShapeGID36.php?shape_gid="+shapeGID+"&token="+token)
      .then(res => res.json())
      .then( (data) => {
        var itemNames=Object.keys(data[0]);

        var headTab='<table class="table" id="testOther"><thead>';
        var dataTab="";

        for(var i in itemNames){headTab+='<th>'+itemNames[i]+'</th>';}
        headTab+='</thead>';

        for(var j in data)
        {
            var itemValues=Object.values(data[j]);
            dataTab+='<tr class="parent" id="' + i + '">';
            for(i in itemValues)dataTab+='<td>'+itemValues[i]+'</td>';
            dataTab+='</tr>';
        }
        var output=headTab+dataTab;
        if(document.getElementById("dataGADM"))
          document.getElementById("dataGADM").innerHTML = output;
    }).catch(console.log);
}*/

export function PlotLine3var(nameDiv,data,data2,data3,title,labels,button=false)
{
    var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    var echelle=0;

    if(!document.getElementById(nameDiv))
      return ;
    var ctx2 = document.getElementById(nameDiv).getContext('2d');
    if(nameDivs[nameDiv])
      nameDivs[nameDiv].destroy()

    var myChart2 = new ChartJS(ctx2, {
        type: 'line',
        data: {
            labels: monthText,
            datasets: [
                {
                    data: data,
                    label: labels[0],
                    borderColor : global.palette3col[0],
                    fill: false

                },
                {
                    data: data2,
                    label: labels[1],
                    borderColor : global.palette3col[1],
                    fill: false

                },
                {
                    data: data3,
                    label: labels[2],
                    borderColor : global.palette3col[2],
                    fill: false

                }]
        },
        options: {
            plugins:{
              title: {
                display: true,
                text: title
              }
            }
//TODO yAxes to update to charJS v2
            /* ,
            scales: {
                yAxes: [
                    {
                        ticks: {
                            callback: function (value) {
                                return (value.toFixed(4) * 100).toFixed(2) + '%'; // convert it to percentage
                            },
                        },
                        scaleLabel: {
                            display: false,
                            labelString: 'Percentage',
                        },
                    },
                ],
            }*/

        }
    });
    nameDivs[nameDiv] = myChart2;


    if(button) {
        document.getElementById(nameDiv + 'B').addEventListener('click', function () {
            if (echelle === 0) {
                myChart2.options.scales.yAxes[0].ticks.min = 0;
                myChart2.options.scales.yAxes[0].ticks.max = 1;
                echelle=1;
                document.getElementById(nameDiv + 'B').firstChild.data  = "Fixed scale";
            } else {

                myChart2.options.scales.yAxes[0].ticks.min = myChart2.options.scales.yAxes[0].ticks.suggestedMin;
                myChart2.options.scales.yAxes[0].ticks.max = myChart2.options.scales.yAxes[0].ticks.suggestedMax;
                document.getElementById(nameDiv + 'B').firstChild.data  = "Dynamic scale"
                echelle=0;
            }

            myChart2.update();
        });
    }
}



export function PlotLine6var(nameDiv,data,data2,data3,data4,data5,data6,title,button=false)
{
    var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    var echelle=0;

    if(!document.getElementById(nameDiv))
      return ;
    var ctx2 = document.getElementById(nameDiv).getContext('2d');
    if(nameDivs[nameDiv])
      nameDivs[nameDiv].destroy()

    var myChart2 = new ChartJS(ctx2, {
        type: 'line',
        data: {
            labels: monthText,
            datasets: [
                {
                    data: data,
                    label: 'family with young children',
                    borderColor : global.palette6col[0],
                    fill: false

                },
                {
                    data: data2,
                    label: 'solo traveller',
                    borderColor : global.palette6col[1],
                    fill: false

                },
                {
                    data: data3,
                    label: 'young couple',
                    borderColor : global.palette6col[2],
                    fill: false

                },
                {
                    data: data4,
                    label: 'group of friends',
                    borderColor : global.palette6col[3],
                    fill: false

                },
                {
                    data: data5,
                    label: 'mature couple',
                    borderColor : global.palette6col[4],
                    fill: false

                },
                {
                    data: data6,
                    label: 'family with older children',
                    borderColor : global.palette6col[5],
                    fill: false

                }
            ]
        },
        options: {
            plugins:{
              title: {
                display: true,
                text: title
              }
            }
            //TODO yAxes to update to charJS v2
/*
          ,
            scales: {
                yAxes: [
                    {
                        ticks: {
                            callback: function (value) {
                                return (value.toFixed(4) * 100).toFixed(2) + '%'; // convert it to percentage
                            },
                        },
                        scaleLabel: {
                            display: false,
                            labelString: 'Percentage',
                        },
                    },
                ],
            }*/
        }
    });
    nameDivs[nameDiv] = myChart2;

    if(button) {
        document.getElementById(nameDiv + 'B').addEventListener('click', function () {
            if (echelle === 0) {
                myChart2.options.scales.yAxes[0].ticks.min = 0;
                myChart2.options.scales.yAxes[0].ticks.max = 1;
                echelle=1;
                document.getElementById(nameDiv + 'B').firstChild.data  = "Fixed scale";
            } else {

                myChart2.options.scales.yAxes[0].ticks.min = myChart2.options.scales.yAxes[0].ticks.suggestedMin;
                myChart2.options.scales.yAxes[0].ticks.max = myChart2.options.scales.yAxes[0].ticks.suggestedMax;
                document.getElementById(nameDiv + 'B').firstChild.data  = "Dynamic scale"
                echelle=0;
            }

            myChart2.update();
        });
    }

}

export function PlotBar2var(nameDiv,data,dataNew,title)
{
    var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    var ctx = document.getElementById(nameDiv).getContext('2d');
    //var myChart =
    new ChartJS(ctx, {
        type: 'bar',
        data: {
            labels: monthText,
            datasets: [
                {
                    data: data,
                    label: '2019',

                },
                {
                    data: dataNew,
                    label: '2020',
                    backgroundColor: '#af90ca'

                }]
        },
        options: {
          plugins:{
            title: {
                display: true,
                text: title
            }
          }
        }
    });
}

var nameDivs = {};

global.plotBarVars = {}

export function PlotBarVars(nameDiv,year,data,title, button=false)
{
  var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  var barVars = global.plotBarVars[nameDiv]
  if(!barVars){
    global.plotBarVars[nameDiv] = [];
    barVars = global.plotBarVars[nameDiv]
  }

    var found = false;
    for(var i=0;i<barVars.length;i++){
      if(barVars[i].label == year){
        barVars[i].data = data;
        found = true;
      }
    }
    if(!found){
      barVars[barVars.length] = {data: data, label:year}
    }
    barVars.sort((a, b) => {
      return a.label - b.label;
    });
    for(var i=0;i<barVars.length;i++){
      barVars[i].backgroundColor = global.palette1[i]
    }
    if(barVars.length < global.years.length)
      return;

    if(!document.getElementById(nameDiv))
      return ;
    var ctx = document.getElementById(nameDiv).getContext('2d');
    var chartjs = {
        type: 'bar',
        data: {
            labels: monthText,
            datasets: barVars
        },
        options: {
          plugins:{
            title: {
                display: true,
                text: title
            }
          }
            //TODO yAxes to update to charJS v2
/*
            ,
            scales: {
                xAxes: [{
                    barPercentage: 0.8
                }]
            }*/
        }
    };
    if(nameDivs[nameDiv])
      nameDivs[nameDiv].destroy()
    nameDivs[nameDiv] = new ChartJS(ctx, chartjs);
}


global.plotLines = {}

export function PlotLines(nameDiv,year,data,title,label,size,button=false)
{
    var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    var lines = global.plotLines[nameDiv]
    if(!lines){
      global.plotLines[nameDiv] = [];
      lines = global.plotLines[nameDiv]
    }

      var found = false;
      for(var i=0;i<lines.length;i++){
        if(lines[i].label == label){
          lines[i].data = data;
          found = true;
        }
      }
      if(!found){
        lines[lines.length] = {data: data, label:label, fill: false}
      }
      lines.sort((a, b) => {
        return a.label - b.label;
      });
      for(var i=0;i<lines.length;i++){
        lines[i].borderColor = global.palette1[i]
      }
      if(lines.length < size)
        return;
    var echelle=0;

    if(!document.getElementById(nameDiv))
      return ;
    var ctx2 = document.getElementById(nameDiv).getContext('2d');
    if(nameDivs[nameDiv])
      nameDivs[nameDiv].destroy()

    var myChart2 = new ChartJS(ctx2, {
        type: 'line',
        data: {
            labels: monthText,
            datasets: lines
        },
        options: {
            plugins:{
              title: {
                display: true,
                text: title
              }
            }
//TODO yAxes to update to charJS v2
            /* ,
            scales: {
                yAxes: [
                    {
                        ticks: {
                            callback: function (value) {
                                return (value.toFixed(4) * 100).toFixed(2) + '%'; // convert it to percentage
                            },
                        },
                        scaleLabel: {
                            display: false,
                            labelString: 'Percentage',
                        },
                    },
                ],
            }*/

        }
    });
    nameDivs[nameDiv] = myChart2;


    if(button) {
        document.getElementById(nameDiv + 'B').addEventListener('click', function () {
            if (echelle === 0) {
                myChart2.options.scales.yAxes[0].ticks.min = 0;
                myChart2.options.scales.yAxes[0].ticks.max = 1;
                echelle=1;
                document.getElementById(nameDiv + 'B').firstChild.data  = "Fixed scale";
            } else {

                myChart2.options.scales.yAxes[0].ticks.min = myChart2.options.scales.yAxes[0].ticks.suggestedMin;
                myChart2.options.scales.yAxes[0].ticks.max = myChart2.options.scales.yAxes[0].ticks.suggestedMax;
                document.getElementById(nameDiv + 'B').firstChild.data  = "Dynamic scale"
                echelle=0;
            }

            myChart2.update();
        });
    }
}


export function PlotBar3var(nameDiv,data18,data19,data20,title, button=false)
{
    var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    if(!document.getElementById(nameDiv))
      return ;
    var ctx = document.getElementById(nameDiv).getContext('2d');
    var chartjs = {
        type: 'bar',
        data: {
            labels: monthText,
            datasets: [
                {
                    data: data18,
                    label: '2018',
                    backgroundColor : global.palette3col[0]

                },
                {
                    data: data19,
                    label: '2019',
                    backgroundColor : global.palette3col[1]

                },
                {
                    data: data20,
                    label: '2020',
                    backgroundColor : global.palette3col[2]

                }]
        },
        options: {
          plugins:{
            title: {
                display: true,
                text: title
            }
          }
            //TODO yAxes to update to charJS v2
/*
            ,
            scales: {
                xAxes: [{
                    barPercentage: 0.8
                }]
            }*/
        }
    };
    if(nameDivs[nameDiv])
      nameDivs[nameDiv].destroy()
    nameDivs[nameDiv] = new ChartJS(ctx, chartjs);
}
/*
export function PlotLine2var(nameDiv,data,dataNew,title)
{
    var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    var ctx2 = document.getElementById(nameDiv).getContext('2d');
    //var myChart2 =
    new ChartJS(ctx2, {
        type: 'line',
        data: {
            labels: monthText,
            datasets: [
                {
                    data: data,
                    label: '2019'

                },
                {
                    data: dataNew,
                    label: '2020',
                    backgroundColor : '#af90ca'

                }]
        },
        options: {
            title: {
                display: true,
                text: title
            }
        }
    });
}
*/

export function getColData(data,colMonth,colData){
    var res=[];

    var indextab=0;
    var j=0;
    while(j<12)
    {
        if (data[indextab]!=undefined && Object.values(data[indextab])[0]==j+1)
        {
            res.push(Object.values(data[indextab])[colData]);
            indextab++;
        }
        else
        {
            res.push(null);
        }
        j++;
    }

    return res;
}

export function getColDataMult(data,colMonth,colData,colData2){
    var res=[];

    var indextab=0;
    var j=0;
    while(j<12)
    {
        if (data[indextab]!==undefined && Object.values(data[indextab])[0]==j+1)
        {
            res.push(Math.round(Object.values(data[indextab])[colData]*Object.values(data[indextab])[colData2]));
            indextab++;
        }
        else
        {
            res.push(null);
        }
        j++;
    }
    return res;
}
